module.exports = __webpack_public_path__ + "static/img/0545_1.4f8c78d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_1.jpg
// module id = pzX7
// module chunks = 1